let service={}
if (window.location.href.startsWith('http://localhost')) {
    service.api = 'http://localhost:6002'
}else{
    service.api = 'https://api-imagex.pyther.com'
}
export default service;
